import BASE from './base'

export default {
  /** Background **/
  background: BASE.greys.black,
  backgroundHover: BASE.teals['dark-mint'],
  backgroundActive: BASE.greys.smoke,
  backgroundDisabled: BASE.greys.gallery,
  backgroundBrand: BASE.blues['dark-midnight'],
  backgroundAccent: BASE.blues['dark-pale-blue'],
  backgroundNotify: BASE.yellows['dark-bisque'],
  backgroundRisk: BASE.reds.espresso,

  /** Texts **/
  text: BASE.greys.gallery,
  textBold: BASE.greys.white,
  textError: BASE.reds.watermelon,
  textHeavy: BASE.blues['dark-midnight'],
  textWeak: BASE.greys['dark-grey'],

  textAccent: BASE.blues['dark-vivid'],
  textAccentBold: BASE.blues['dark-midnight'],
  textAccentWeak: BASE.blues.spindle,

  textNotify: BASE.yellows.apricot,
  textNotifyBold: BASE.yellows.bisque,
  textNotifyWeak: BASE.yellows.saffron,

  textRisk: BASE.reds.floral,
  textRiskBold: BASE.reds['dark-espresso'],
  textRiskWeak: BASE.reds.cupid,

  textOnColor: BASE.blues['dark-pale-blue'],
  textOnColorBold: BASE.greys.black,
  textOnColorWeak: BASE.blues.danube,

  /** Links **/
  link: BASE.teals['dark-atoll'],
  linkHover: BASE.teals['dark-aquamarine'],
  linkDisabled: BASE.greys.silver,

  linkIcon: BASE.teals['atoll-icons'],
  linkIconActive: BASE.teals.mint,

  linkOnColor: BASE.teals.moss,
  linkOnColorHover: BASE.teals['dark-mint'],

  /** Buttons **/

  button: {
    primary: {
      bg: BASE.teals['dark-atoll'],
      bgActive: BASE.teals['dark-aquamarine'],
      bgDisabled: BASE.greys.gallery,
      bgHover: BASE.teals['dark-aquamarine'],
      border: BASE.teals['dark-atoll'],
      borderActive: BASE.teals['dark-atoll'],
      borderDisabled: BASE.greys.gallery,
      borderHover: BASE.teals['dark-aquamarine'],
      icon: BASE.greys.black,
      iconDisabled: BASE.greys.stone,
      focusInset: BASE.greys.black,
      text: BASE.greys.black,
      textDisabled: BASE.greys.stone,
    },
    secondary: {
      bg: 'transparent',
      bgActive: BASE.teals['dark-aquamarine'],
      bgDisabled: 'transparent',
      bgHover: BASE.teals['dark-aquamarine'],
      border: BASE.teals['dark-atoll'],
      borderActive: BASE.teals['dark-atoll'],
      borderDisabled: BASE.greys.stone,
      borderHover: BASE.teals['dark-atoll'],
      icon: BASE.teals['dark-atoll'],
      iconDisabled: BASE.greys.silver,
      focusInset: BASE.teals.atoll,
      text: BASE.teals['dark-atoll'],
      textDisabled: BASE.greys.silver,
    },
    onColor: {
      bg: BASE.greys.black,
      bgActive: BASE.teals['dark-mint'],
      bgDisabled: BASE.blues.danube,
      bgHover: BASE.teals['dark-mint'],
      border: BASE.greys.black,
      borderActive: BASE.greys.black,
      borderDisabled: BASE.blues.danube,
      borderHover: BASE.teals['dark-mint'],
      icon: BASE.teals['dark-atoll'],
      iconDisabled: BASE.teals.moss,
      focusInset: BASE.teals['dark-atoll'],
      text: BASE.teals['dark-atoll'],
      textDisabled: BASE.teals.moss,
    },
    secondaryOnColor: {
      bg: 'transparent',
      bgActive: BASE.blues['dark-aquamarine'],
      bgDisabled: 'transparent',
      bgHover: BASE.blues['dark-aquamarine'],
      border: BASE.teals.moss,
      borderActive: BASE.teals.moss,
      borderDisabled: BASE.blues.danube,
      borderHover: BASE.teals.moss,
      icon: BASE.teals.moss,
      iconDisabled: BASE.blues.danube,
      focusInset: BASE.teals.moss,
      text: BASE.teals.moss,
      textDisabled: BASE.blues.danube,
    },
    accent: {
      bg: BASE.blues.danube,
      bgActive: BASE.blues['dark-vivid'],
      bgDisabled: BASE.blues.vivid,
      bgHover: BASE.blues['dark-vivid'],
      border: BASE.blues.danube,
      borderActive: BASE.blues.oyster,
      borderDisabled: BASE.blues.vivid,
      borderHover: BASE.blues['dark-vivid'],
      icon: BASE.blues['dark-midnight'],
      iconDisabled: BASE.blues['dark-midnight'],
      focusInset: BASE.blues.midnight,
      text: BASE.blues['dark-midnight'],
      textDisabled: BASE.blues['dark-midnight'],
    },
    notify: {
      bg: BASE.yellows['dark-apricot'],
      bgActive: BASE.yellows['dark-saffron'],
      bgDisabled: BASE.yellows['dark-bisque'],
      bgHover: BASE.yellows['dark-saffron'],
      border: BASE.yellows['dark-apricot'],
      borderActive: BASE.yellows['dark-apricot'],
      borderDisabled: BASE.yellows['dark-bisque'],
      borderHover: BASE.yellows['dark-saffron'],
      icon: BASE.yellows.apricot,
      iconDisabled: BASE.yellows.apricot,
      focusInset: BASE.greys.black,
      text: BASE.yellows.apricot,
      textDisabled: BASE.yellows.apricot,
    },
    risk: {
      bg: BASE.reds.rust,
      bgActive: BASE.reds.watermelon,
      bgDisabled: BASE.reds['dark-blush'],
      bgHover: BASE.reds.watermelon,
      border: BASE.reds.rust,
      borderActive: BASE.reds.amaranth,
      borderDisabled: BASE.reds['dark-blush'],
      borderHover: BASE.reds.watermelon,
      icon: BASE.reds.floral,
      iconDisabled: BASE.reds.floral,
      focusInset: BASE.greys.black,
      text: BASE.reds.floral,
      textDisabled: BASE.reds.floral,
    },
    highRisk: {
      bg: BASE.reds.watermelon,
      bgActive: BASE.reds.amaranth,
      bgDisabled: BASE.reds['dark-blush'],
      bgHover: BASE.reds.amaranth,
      border: BASE.reds.watermelon,
      borderActive: BASE.reds.watermelon,
      borderDisabled: BASE.reds['dark-blush'],
      borderHover: BASE.reds.amaranth,
      icon: BASE.greys.black,
      iconDisabled: BASE.greys.black,
      focusInset: BASE.greys.black,
      text: BASE.greys.black,
      textDisabled: BASE.greys.black,
    },
  },

  /** Boarders **/
  border: BASE.greys.silver,
  borderHover: BASE.greys.mortar,
  borderActive: BASE.teals.aquamarine,
  borderDisabled: BASE.greys.stone,
  borderAccent: BASE.blues['dark-vivid'],
  borderNotify: BASE.yellows['dark-saffron'],
  borderRisk: BASE.reds.watermelon,

  /** Icons **/
  icon: BASE.greys.silver,
  iconHover: BASE.greys.mortar,
  iconDisabled: BASE.greys.stone,

  iconWeak: BASE.greys.stone,
  iconWeakHover: BASE.greys.silver,
  iconWeakDisabled: BASE.greys.gallery,

  iconOnColor: BASE.greys.black,
  iconOnColorHover: BASE.blues.danube,
  iconOnColorDisabled: BASE.blues.danube,

  iconButtonOnColor: BASE.teals.moss,
  iconButtonOnColorDisabled: BASE.blues.danube,

  iconAccent: BASE.blues['dark-vivid'],
  iconAccentHover: BASE.blues['dark-midnight'],
  iconAccentDisabled: BASE.blues.danube,

  iconNotify: BASE.yellows.apricot,
  iconNotifyHover: BASE.yellows.bisque,
  iconNotifyDisabled: BASE.yellows['dark-saffron'],

  iconRisk: BASE.reds.floral,
  iconRiskHover: BASE.reds['dark-espresso'],
  iconRiskDisabled: BASE.reds['dark-blush'],

  /** Support pills **/
  supportInfo: BASE.greys.silver,
  supportEngage: BASE.teals['dark-atoll'],
  supportAccent: BASE.blues['dark-vivid'],
  supportNotify: BASE.yellows['dark-saffron'],
  supportRisk: BASE.reds.amaranth,
  supportText: BASE.greys.black,

  /** Fields **/
  fieldBackground: BASE.greys.black,
  fieldBackgroundAccent: BASE.blues['dark-pale-blue'],
  fieldLabel: BASE.teals.atoll,
  fieldIcon: BASE.greys.silver,
  fieldPlaceholder: BASE.greys.stone,

  /** Booleans **/
  boolean: BASE.teals['dark-aquamarine'],
  booleanHover: BASE.teals['dark-atoll'],
  booleanActive: BASE.teals['dark-atoll'],
  booleanDisabled: BASE.greys.silver,

  /** Misc **/
  overlay: '#ffffff7a', // greys.white at 48% opacity
  shLogo: BASE.greys.black,
}
